import React, { useState } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import './App.css';

import { createTheme } from '@mui/material';
import { AppBar } from './Components/AppBar';
import { LoginPage } from './Pages/LoginPage';
import { Routes } from './routes';
import { Context } from './services/context';
import { RestorePasswordPage } from './Pages/RestorePassword';

let theme = createTheme({
  typography: {
    fontFamily: 'Inter, sans-serif',
    button: {
      textTransform: 'none',
    },
  },
  palette: {
    primary: {
      main: '#ffffff',
      // dark: '#EB564F',
    },
    secondary: {
      main: '#FF7221',
    },
  },
});

type UserData = {
  email: string;
  role: string;
  id: string;
};

const App = () => {
  const [loogedin, setLogin] = useState(!!localStorage.getItem('profile'));
  const [userData, setUserData] = useState<UserData>({
    email: '',
    role: '',
    id: '',
  });

  const history = useHistory();
  if (
    localStorage.getItem('profile') &&
    userData.email === '' &&
    userData.role === '' &&
    userData.id === ''
  ) {
    const dat = localStorage.getItem('profile');
    if (dat) {
      setUserData({
        email: JSON.parse(dat).data.user.email.split('@')[0] || '',
        role: JSON.parse(dat).data.user.roleName,
        id: JSON.parse(dat).data.user.id.toString(),
      });
    }
  }
  const { pathname } = useLocation();
  theme = responsiveFontSizes(theme, { factor: 5 });

  const handleUserLogin = (login: string) => {
    localStorage.setItem('login', JSON.stringify({ login }));
  };

  const splitPathName = pathname.split('/');
  const routeName = splitPathName[1];
  const token = splitPathName[2];
  // if (loogedin && (pathname === '/' || pathname === '/login')) {
  //   history.push('/structure');
  // }
  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <Context.Provider
          value={{
            loogedin,
            setLogin,
            setUserData,
            userData,
          }}
        >
          <ThemeProvider theme={theme}>
            {loogedin ? (
              <AppBar />
            ) : routeName === 'restorePassword' ? (
              <RestorePasswordPage token={token} />
            ) : (
              <LoginPage handleUserLogin={handleUserLogin} />
            )}

            {loogedin ? <Routes /> : null}
            {loogedin && (pathname === '/' || pathname === '/login') ? (
              <Redirect to="/structure" />
            ) : null}
          </ThemeProvider>
        </Context.Provider>
      </DndProvider>
    </>
  );
};

export default App;
